import { CastTrialState } from './types';

export const _CASTAI_TRIAL: CastTrialState = {} as never;
